import { Text } from "@assetwatch/ui";
import type { ReactNode } from "react";

export function formatDate(value: string | null) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.valueOf())) return "—";
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}

export function formatCost(value: number | null, currency: string | null) {
  if (value === null) return "—";
  return `${currency ? `${currency} ` : ""}$${value.toFixed(2)}`;
}

export function Field({
  label,
  value,
  children,
}: {
  label: string;
  value?: string | null;
  children?: ReactNode;
}) {
  return (
    <div className="flex min-w-0 flex-col gap-(--spacing-6)">
      <Text size="sm" tone="subtle">
        {label}
      </Text>
      {children ?? <Text>{value || "—"}</Text>}
    </div>
  );
}

export function DetailCard({
  id,
  title,
  actions,
  children,
}: {
  id?: string;
  title: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section
      className="scroll-mt-(--spacing-24) overflow-hidden rounded-(--radius-md) border border-outline-subtle bg-surface"
      id={id}
    >
      <div className="flex items-center justify-between gap-(--spacing-12) border-b border-outline-subtle bg-surface-container-low px-(--spacing-16) py-(--spacing-12)">
        <Text>{title}</Text>
        {actions}
      </div>
      {children}
    </section>
  );
}

export function DetailGrid({ children }: { children: ReactNode }) {
  return (
    <div className="grid grid-cols-1 gap-x-(--spacing-32) gap-y-(--spacing-20) px-(--spacing-20) py-(--spacing-20) sm:grid-cols-2 lg:grid-cols-3">
      {children}
    </div>
  );
}
